import { render, staticRenderFns } from "./user-teams.vue?vue&type=template&id=32f6d89d&scoped=true"
import script from "./user-teams.vue?vue&type=script&lang=js"
export * from "./user-teams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f6d89d",
  null
  
)

export default component.exports